import React, { useMemo } from 'react'
import { StyleSheet } from 'react-native'
import { Text } from 'react-native-paper'
import { helpers } from '@linqpal/common-frontend'
import { commonColors } from '@linqpal/common-frontend/src/theme/colors'

const { composeStyle } = helpers

const styles = StyleSheet.create({
  label: {
    fontSize: 15,
    fontWeight: '400',
    lineHeight: 24,
  },
})

export default function Label(props) {
  const { color, style } = props

  const labelStyle = useMemo(() => {
    return composeStyle(
      styles.label,
      { color: color || commonColors.secondaryDark },
      style,
    )
  }, [color, style])
  return (
    <Text style={labelStyle} testID={props.testID}>
      {props.children}
    </Text>
  )
}
